import React, { useMemo } from 'react';
import { Table, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import Column from '../../helpers/columns';
import useDatasource from '../../hooks/useDatasource';
import {
  getRetailUsers,
  downLoadRetailUsers,
} from '../../services/admin/users';
import EditItemIcon from '../buttons/EditItemIcon';
import ExportEntitiesButton from '../buttons/ExportEntitiesButton';
import PageTitle from '../PageTitle';
import usePermissions from '../../hooks/usePermission';
import ViewItemIcon from '../buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['MANAGEMENT_RETAILERS_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'HEAD_RETAILER'],
};

const RetailList = () => {
  const [t] = useTranslation();
  const { canView, canEdit } = usePermissions(permissionsMap);
  const { pagination, criterias, content, handleChange, sort } = useDatasource(
    (args) => {
      return getRetailUsers({
        ...args,
        criterias: { ...args.criterias },
      });
    },
    {
      sort: ['fullname', 'asc'],
    },
  );

  const columns = useMemo(
    () => [
      Column.text('fullname', t('entity.admin.user.fullname'), {
        sort: true,
        filter: true,
      }),
      Column.text('identityCard', t('entity.admin.user.identityCard'), {
        sort: false,
        filter: true,
      }),
      Column.text('retailerName', t('entity.taxonomy.retailer._singular')),
      Column.text('posName', t('entity.taxonomy.poses._singular'), {
        sort: true,
        filter: true,
      }),
      Column.actions(
        t('table.actions'),
        ({ id, retailerId }) =>
          retailerId && (
            <>
              {canView && <ViewItemIcon path={`/retail/${id}`} />}
              {canEdit && <EditItemIcon path={`/retail/${id}`} />}
            </>
          ),
      ),
    ],
    [canEdit, canView, t],
  );

  return (
    <>
      <PageTitle>
        <Space>
          <ExportEntitiesButton
            columns={columns}
            data={{
              sort,
              criterias,
            }}
            downloadFiles={downLoadRetailUsers}
          />
        </Space>
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </>
  );
};
export default RetailList;
